export default "__VITE_ASSET__BvtbSHZK__"